// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"32":"4afedb82","299":"051cdaf9","666":"5851dfe8","807":"d2ea9b31","936":"6f49507d"}[chunkId] + ".js";
};